const FONTS = {
    primaryFont: '"proxima-nova", "open Sans", "Helvetica", "Arial", sans-serif',
    milbPrimary: 'Lato, "Helvetica Neue", Helvetica, Arial, sans-serif'
};

export default FONTS;
